import React, { PureComponent } from 'react';
import InstallableAppCenterFooter, { BoldHeader } from './InstallableAppCenterFooter';
export default class InstallableAppAlreadyInstalledMessage extends PureComponent {
  render() {
    return /*#__PURE__*/React.createElement(InstallableAppCenterFooter, null, /*#__PURE__*/React.createElement(BoldHeader, null, "We're seeing double!"), /*#__PURE__*/React.createElement("div", null, "This app is already added to ", this.props.hostConfig.installationLocation, "."));
  }
}